document.addEventListener('DOMContentLoaded', function () {
  const encodedLinks = document.querySelectorAll('[data-encoded]');

  encodedLinks.forEach(function (item) {
    item.removeEventListener('click', handleClick);
    item.addEventListener('click', handleClick);
  });

  function handleClick(e) {
    const decodedUrl = atob(this.getAttribute('data-encoded'));
    window.location.href = decodedUrl;
  }
});